export default __webpack_public_path__ + "static/media/sk.ebfc59b1.svg";